<div class="card">
  <ion-row class="align-items-start">
    <ion-col size="12" size-lg="6">
      <h3>We’re Here to <ion-text color="warning">Help</ion-text></h3>
    </ion-col>
    <ion-col size="12" size-lg="6">
      <p>Have questions about Satel, need support, or want to learn more about how our company can make a difference? We’d love to hear from you!</p>
      <div class="sm-wrapper">
        @for (sm of smLinks; track sm) {
          <a class="link" [href]="sm.link" target="_blank"><ion-icon [name]="sm.icon"></ion-icon></a>
        }
      </div>
    </ion-col>
  </ion-row>
</div>
